// Colour helpers copied from trustshop-fe src/utils/colorConvert.js (parseColor,
// flattenColor) so the portal resolves palette colours the same way the admin does.

function hexToRgb(hex) {
    hex = hex.replace(/^#/, "");
    if (hex.length === 3) hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    const num = parseInt(hex.slice(0, 6), 16);
    return [(num >> 16) & 255, (num >> 8) & 255, num & 255];
}

/** Parse a colour string (hex3/6/8, rgb/rgba) → { rgb: [r, g, b], alpha } or null */
export function parseColor(color) {
    if (!color) return null;

    let rgb;
    let alpha = 1;

    const rgbaMatch = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)/);
    const hex8Match = color.match(/^#?([0-9A-Fa-f]{6})([0-9A-Fa-f]{2})$/);
    const hexMatch = color.replace(/^#/, "").match(/^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/);

    if (rgbaMatch) {
        rgb = [parseInt(rgbaMatch[1]), parseInt(rgbaMatch[2]), parseInt(rgbaMatch[3])];
        alpha = rgbaMatch[4] !== undefined ? parseFloat(rgbaMatch[4]) : 1;
    } else if (hex8Match) {
        rgb = hexToRgb(hex8Match[1]);
        alpha = parseInt(hex8Match[2], 16) / 255;
    } else if (hexMatch) {
        rgb = hexToRgb(color);
    } else {
        return null;
    }

    return { rgb, alpha };
}

/**
 * Composite colour layers (front/topmost first → back) into one opaque
 * `rgb(r, g, b)`, onto white when every layer is translucent. A translucent
 * secondary button (e.g. rgba(255,255,255,0.2) in dark) only means something
 * over what it sits on; a popover panel floating over text needs it solid.
 * Unparseable layers are skipped; null when nothing parses.
 */
export function flattenColor(...layers) {
    const stack = layers.map(parseColor).filter(Boolean);
    if (!stack.length) return null;

    let base = [255, 255, 255];
    for (let i = stack.length - 1; i >= 0; i--) {
        const { rgb, alpha } = stack[i];
        base = base.map((channel, c) => Math.round(rgb[c] * alpha + channel * (1 - alpha)));
    }
    return `rgb(${base.join(", ")})`;
}
